import { http } from './config'

export default {

  getAllBays: () => {
    return http.get('bays')
  },

  getBayById: (bayId) => {
    return http.get('bays/' + bayId)
  },

  getAllVehicleBaysById: (vehicleBaysId) => {
    return http.get('vehicle_types/' + vehicleBaysId)
  },

  createVehicleBay: (bayParams) => {
    let labelUpperCase = bayParams.name.toUpperCase()
    return http.post('bays', {
      name: labelUpperCase,
      bay_type_id: bayParams.bay_type_id.id,
      vehicle_type_id: bayParams.vehicle_type_id,
      sequence: bayParams.sequence,
      pallet_percentage: bayParams.palletPercentage
    })
  },

  updateVehicleBay: (vehicleBaysParams) => {
    let labelUpperCase = vehicleBaysParams.name.toUpperCase()
    return http.put('bays/' + vehicleBaysParams.bayId, {
      name: labelUpperCase,
      bay_type_id: vehicleBaysParams.bay_type_id.id,
      vehicle_type_id: vehicleBaysParams.vehicle_type_id,
      sequence: vehicleBaysParams.sequence,
      pallet_percentage: vehicleBaysParams.palletPercentage
    })
  },

  deleteVehicleBay: (bayId) => {
    return http.delete('bays/' + bayId)
  },

  editVehicleBay: (bayId) => {
    return http.get('bays/' + bayId)
  },

  saveSequence: (sequence, bayId) => {
    return http.put('bays/' + bayId + '/bay_sequence', {
      sequence: sequence,
    })
  },
}
